import React from "react";
import { Wrapper } from "./styled";

const FiltersBar = ({ children, ...rest }) => {
  return <Wrapper {...rest}>{children}</Wrapper>;
};

export default FiltersBar;
